export const hubs = [
    {
        title: `Data at a Glance`,
        id: 4,
        subtitle: ``,
        color: 'blue',
        color_text: 'blue--text'
    },
    {
        title: `News`,
        id: 2,
        subtitle: `Check out below for Industry related news and Insights`,
        color: 'orange',
        color_text: 'orange--text'
    },
    {
        icon: 'ring_volume',
        title: `Communication`,
        id: 3,
        subtitle: `The list for RSI announcements`,
        color: 'teal',
        color_text: 'teal--text'
    },

];
